export var ShoppingListApiErrorType;
(function (ShoppingListApiErrorType) {
    ShoppingListApiErrorType["SHOPPING_LIST_NOT_FOUND_ERROR"] = "shopping-lists.errors.shoppingListNotFound";
    ShoppingListApiErrorType["OUTDATED_SHOPPING_LIST_ERROR"] = "shopping-lists.errors.outdatedShoppingListError";
    ShoppingListApiErrorType["SHOPPING_LIST_ORDERED_INVALID_STATUS"] = "shopping-lists.errors.shoppingListOrderedInvalidStatus";
    ShoppingListApiErrorType["NOT_ALLOW_TO_DELETE"] = "shopping-lists.errors.notAllowToDelete";
    ShoppingListApiErrorType["CANNOT_CHECKOUT_SHOPPING_LIST_WRONG_STATUS_ERROR"] = "checkout.cannotCheckoutShoppingListWrongStatusError";
})(ShoppingListApiErrorType || (ShoppingListApiErrorType = {}));
//# sourceMappingURL=shopping-list.errors.js.map